import { useEffect } from 'react';
// Allows callers (e.g. ProviewContext automated redirects) to imperatively
// suppress the dialog before a programmatic navigation. window.onbeforeunload = null
// does not remove listeners registered via addEventListener, so this flag is needed.
let suppressed = false;
export const suppressBeforeUnloadGuard = () => {
    suppressed = true;
};
/**
 * Attaches a native `beforeunload` dialog when `isActive` is true.
 * The browser shows its own generic message — no custom text is possible.
 * Remove the guard by passing `false` (e.g. after the session is submitted).
 */
export const useBeforeUnloadGuard = (isActive) => {
    useEffect(() => {
        if (!isActive)
            return;
        const handleBeforeUnload = (event) => {
            if (suppressed)
                return;
            event.preventDefault();
            // Legacy browsers require a truthy returnValue to trigger the dialog.
            event.returnValue = true;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isActive]);
};
